<script setup>
import SiteContent from '#/layout/components/SiteContent.vue'
import SiteFooterSkinny from '#/layout/components/SiteFooterSkinny.vue'
import SiteHeaderSkinny from '#/layout/components/SiteHeaderSkinny.vue'
import SkipNav from '@/libvue/components/skipnav/SkipNav.vue'
</script>

<template>
  <div id="rcMainWrapper" class="rc-wrapper rc-skinny-layout" tabindex="-1">
    <SkipNav />
    <SiteHeaderSkinny />
    <SiteContent />
    <SiteFooterSkinny />
  </div>
</template>
